var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_2621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06005 8.6H6.43005V21.75H2.06005V8.59V8.6ZM4.27005 2.25C2.77005 2.25 1.80005 3.23 1.80005 4.52C1.80005 5.78 2.75005 6.8 4.22005 6.8H4.24005C5.77005 6.8 6.72005 5.78 6.72005 4.52C6.69005 3.23 5.77005 2.25 4.27005 2.25ZM17.17 8.28C16.3767 8.24822 15.5899 8.43467 14.8952 8.81905C14.2005 9.20343 13.6246 9.771 13.23 10.46V8.59H8.85005C8.91005 9.83 8.85005 21.75 8.85005 21.75H13.23V14.4C13.23 14 13.25 13.62 13.37 13.33C13.69 12.55 14.41 11.73 15.61 11.73C17.2 11.73 17.83 12.94 17.83 14.71V21.75H22.2001V14.21C22.2001 10.16 20.05 8.28 17.17 8.28Z",
    fill: "#FFFDFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_2621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4178cf0c883841ca6988f04147190088.svg";
export { ForwardRef as ReactComponent };